(function (angular, app) {
    "use strict";

    angular.module(app.modules.group.name)
       .controller(app.modules.group.routes.detail.controller, GroupDetailController);

    GroupDetailController.$inject = ["$scope", "$sce", "$timeout", "ngDialog", "$routeParams", "$q", "$location"
       , app.modules.common.constants.appsettings
       , app.modules.group.services.groups
       , app.modules.member.services.search
       , app.modules.common.constants.appmessaging
       , app.modules.common.services.functions
       , app.modules.common.services.storage
       , app.modules.invitation.services.invite
       , app.modules.common.constants.themelist
       , app.modules.outing.services.outings
       , app.modules.ui.services.alerts
       , app.modules.common.services.eventbus,
        'GroupMemory',
        'Member'
    ];

    function GroupDetailController($scope, $sce, $timeout, ngDialog, $routeParams, $q, $location
       , ggSettings
       , ggGroupSvc
       , ggMemberSearchSvc
       , ggMessaging
       , ggFunctions
       , ggStorage
       , ggInvitationSvc
       , ggThemes
       , ggOutingSvc
       , ggAlertSvc
       , ggEvents,
       GroupMemory,
       Member
    ) {

        $scope.Group = null;
        $scope.InlineAlert = new ggAlertSvc.inline;
        $scope.PopupAlert = new ggAlertSvc.popup;


        var ctrl = this, vm = $scope.vm = {};

        $scope.View = {
            tabs: {
                current: 1
               , types: {
                   home: 1
                  , invited: 2
                  , organize: 3
                  , reports: 4,
                   memories: 5
               }
               , isActive: function (tab) {
                   return tab == $scope.View.tabs.current;
               }
               , select: function (tab) {

                   if (!tab) {
                       tab = $scope.View.tabs.current;
                   }

                   $scope.View.tabs.current = tab;
                   if (tab == $scope.View.tabs.types.invited) {
                       $scope.Content.invited.fetch();
                   }
                   if (tab == $scope.View.tabs.types.organize) {
                       $scope.Content.organize.tabs.select($scope.Content.organize.tabs.types.edit);
                   }
                   if (tab == $scope.View.tabs.types.reports && !$scope.currentReport) {
                       
                   }
                   if (tab == $scope.View.tabs.types.memories) {
                       if (!vm.memories) {
                           vm.getMemoryList();
                       }
                   }
               }
            }
        }
        $scope.Membership = {};
        $scope.Temp = {
            isLoaded: false
           , isSwiper: false
           , isJumboExpanded: false
           , invitationId: 0
           , eventCount: 0
           , memberCount: 0
           , myPlayerId: app.Member.Detail.id
           , handicapTypes: app.modules.group.constants.handicapTypes
           , themes: ggThemes
        }


        $scope.Content = {
            init: function () {

                if (!$scope.Group || ($scope.Group && !$scope.Group.isActive)) {
                    $scope.f.notFound();
                    // page is loaded
                    $scope.Temp.isLoaded = true;
                } else {

                    // isPageAdmin
                    if ($scope.Group.createdBy.id == app.Member.Detail.id) {
                        $scope.Temp.isPageAdmin = true;
                    }

                    // Is Group Member
                    var isGroupMember = function () {
                        return ggGroupSvc.membership.fetchGroupMembership($scope.Group.id, app.Member.Detail.id).then(function (data) {
                            if (data && data.status == "200") {
                                if (data.data.value.length > 0) {
                                    if (data.data.value[0].isActive) {
                                        $scope.Temp.isPageMember = true;
                                    }
                                }
                            }
                            return;
                        });
                    }
                    // Is Invited
                    /*
                    var isInvited = function () {
                        if (!$scope.f.isPageMember()) {
                            return app.Member.Network.Data.Invitations.fetch(true).then(function (data) {
                                if (data && data.length > 0) {
                                    for (var i = 0; i < data.length; i++) {
                                        var inv = data[i];
                                        if (inv.groupId == $scope.Group.id) {
                                            $scope.Temp.invitationId = inv.id;
                                        }
                                    }
                                }
                                return;
                            });
                        } else {
                            return $q;
                        }
                    }
                    */
                    // Outings if 
                    var fetchOutings = function () {
                        return ggOutingSvc.search.fetchOutings({ groupId: $scope.Group.id }).then(function (data) {
                            if (data && data.status == "200") {
                                var results = data.data.value;
                                $scope.Content.home.results = results;
                            }
                            $scope.Content.home.isSearch = true;
                            return;
                        });
                    }

                    return isGroupMember().then(function () {
                        if (!$scope.f.isPrivate() || ($scope.f.isPageAdmin() || $scope.f.isPageMember())) {
                            fetchOutings();
                        } else {
                            var btn = new ggAlertSvc.button;
                            btn.name = "OK";
                            btn.callback = function(){
                                ggFunctions.goToPage("/");
                            };



                            $scope.PopupAlert.fail("Group Hidden", "This group is hidden.  You can only see this group if you are a member.", [btn])
                        }
                    }).finally(function () {
                        // page is loaded
                        ggFunctions.toggleProcessing(false);
                        $scope.Temp.isLoaded = true;
                        $scope.View.tabs.select();
                    });
                }



            }
           , home: {
               results: []
              , isSearch: false
              , tabs: {
                  current: 1
                 , types: {
                     outings: 1
                    , calendar: 2
                 }
                 , isActive: function (tab) {
                     return tab == $scope.Content.home.tabs.current;
                 }
                 , select: function (tab) {
                     $scope.Content.home.tabs.current = tab;
                 }
              }
              , select: function (id) {
                  ggFunctions.goToPage(app.modules.outing.routes.detail.path + "?outingId=" + id);
              }
              , newOuting: function () {
                  ggFunctions.goToPage(app.modules.outing.routes.setup.path + "?groupId=" + $scope.Group.id);
              }
           }
           , invited: {
               tabs: {
                   current: 1
                  , types: {
                      confirmed: 1
                     , pending: 2
                     , declined: 3
                     , add: 4
                     , sendemail: 5
                  }
                  , isActive: function (tab) {
                      return tab == $scope.Content.invited.tabs.current;
                  }
                  , select: function (tab) {
                      $scope.Content.invited.tabs.current = tab;

                      if ($scope.Content.invited.tabs.current == $scope.Content.invited.tabs.types.sendemail) {
                          $scope.Content.invited.sendemail.fill();
                      }

                      $scope.Content.invited.fetch()
                  }
               }
              , results: []
              , isLoaded : false
              , confirmed: {
                  results: []
                  , filter :""
                  , isSearch: false
                  , select: function (membership, ix) {
                     if (!$scope.Temp.isSwiper) {
                         $scope.Membership = angular.copy(membership);
                         $scope.Membership.member.repassword = $scope.Membership.member.password;

                         $scope.Membership.Temp = {
                             handicap: membership.handicaps.length > 0 ? membership.handicaps[0].value : null
                            , isUpdateGroup: false
                         }
                         // 
                         var shouldSave = false, shouldSaveMemberInfo = false;
                         var _membershipModal = ngDialog.open({
                             template: ggFunctions.cacheBuster("app/group/controllers/membership-modal.html")
                            , closeByEscape: false
                            , closeByDocument: false
                            , showClose: false
                            , className: "fullscreen"
                            , scope: $scope,
                             preCloseCallback: function (value) {
                                 // Note: form gets destroyed after this call, so we cannot
                                 // use it in the close promise.
                                 var form = $scope.Membership.Temp.form;
                                 shouldSave = form.$valid && form.$dirty;
                                 shouldSaveMemberInfo = angular.isDefined(form.userName);
                                 return form.$valid ? true : confirm('The form has validation errors.  Do you want to close without saving?');
                             }
                         });

                         _membershipModal.closePromise.then(function () {
                             if (shouldSave) {
                                 ggFunctions.toggleProcessing.bind(null, true);
                                 $q.all([saveMemberInfo(), saveHandicap()])
                                     .catch(handleError)
                                     .finally(ggFunctions.toggleProcessing.bind(null, false));
                             }

                             function saveMemberInfo() {
                                 var data = $scope.Membership.member,
                                     member;

                                 return shouldSaveMemberInfo
                                     ? new Member(createDto(data)).$patch(success)
                                     : null;

                                 function createDto(data) {
                                     var result = { id: data.id, userName: data.userName, email: data.email, password: data.password, firstName: data.firstName, lastName: data.lastName, mobilePhone: data.mobilePhone };
                                     if (result.password == null)
                                         delete result.password;
                                     return result;
                                 }

                                 function success(res) {
                                     angular.extend(membership.member, createDto(res));
                                 }
                             }
                             function saveHandicap() {
                                 var oldh = $scope.Membership.handicaps.length > 0 ? $scope.Membership.handicaps[0].value : null;
                                 var newh = $scope.Membership.Temp.handicap
                                 if (oldh != newh) {
                                     var isOK = true;
                                     var updateMembershipHandicap = function () {
                                         return ggGroupSvc.membership.autoUpdateGroupHandicap({
                                             groupId: $scope.Group.id,
                                             membershipId: $scope.Membership.id,
                                             handicap: newh,
                                             effectiveOn: null
                                         }).then(function (data) {
                                             if (data && data.status == "200") {
                                                 var newHandicap = {
                                                     value: newh
                                                    , id: $scope.Membership.id
                                                       , effectiveOn: ggFunctions.formatDateString(null, 'yyyy-mm-dd', null)
                                                 }
                                                 $scope.Content.invited.confirmed.results[ix].handicaps = [newHandicap];
                                             } else {
                                                 $scope.PopupAlert.fail("Error", data.statusMsg);
                                             }
                                             return;
                                         }, function (error) {
                                             isOK = false;
                                             // $scope.PopupAlert.fail("Error", "There was an error updating the member handicap.");
                                             return;
                                         }).finally(function () {
                                             $scope.Content.invited.confirmed.swipe.selected = 0;
                                         });
                                     };

                                     return updateMembershipHandicap().finally(function () {
                                         $scope.Membership = null;
                                     });

                                 }
                                 else {
                                     $scope.Membership = null
                                 }
                                 $scope.Content.invited.confirmed.swipe.selected = 0;
                             }
                             function handleError() {
                                 $scope.PopupAlert.fail("Error", "There was an error saving.");
                             }
                         });
                     }
                 }
                 , remove: function (membership, ix) {

                     var isOK = true;
                     var removePlayer = function (membershipId) {
                         return ggGroupSvc.membership.deleteGroupMembership({
                             groupId: $scope.Group.id, membershipId: membershipId
                         }).then(function (data) {
                             if (data && data.status == "204") {
                                 $scope.Content.invited.confirmed.results.splice(ix, 1);
                             }
                             return;
                         }, function (error) {
                             isOK = false;
                             $scope.PopupAlert.fail("Error", "There was an error removing the player from the group.");
                             return;
                         });
                     }

                     if (membership.member.id == $scope.Group.createdBy.id) {
                         $scope.PopupAlert.warn("Sorry", "You can't remove the group organizer.")
                     } else {
                         ggFunctions.toggleProcessing(true);
                         removePlayer(membership.id).then(function () {
                             if (isOK) {
                                 // Nothing to do
                             }
                         }).finally(function () {
                             ggFunctions.toggleProcessing(false);
                         });
                     }

                 }
                 , swipe: {
                     selected: 0
                    , left: function (id) {
                        $scope.f.isSwiper();
                        $scope.Content.invited.confirmed.swipe.selected = id;
                    }
                    , right: function (id) {
                        $scope.f.isSwiper();
                        $scope.Content.invited.confirmed.swipe.selected = 0;
                    }
                    , isSelected: function (id) {
                        return id == $scope.Content.invited.confirmed.swipe.selected;
                    }
                 }
              }
              , fetch: function () {
                  // Players
                  if ($scope.Content.invited.confirmed.results.length == 0) {
                      //ggFunctions.toggleProcessing(true);
                      $scope.Content.invited.confirmed.isSearch = false;
                      ggMemberSearchSvc.search.fetchMemberSearchByGroup({ groupId: $scope.Group.id }).then(function (data) {
                          if (data && data.status == "200") {
                              $scope.Content.invited.confirmed.results = data.data.value;
                          }
                      }).finally(function () {
                          //ggFunctions.toggleProcessing(false);
                          $scope.Content.invited.confirmed.isSearch = true;
                      });
                  }
              }

           }
           , organize: {
               tabs: {
                   current: 1
                  , types: {
                      edit: 1
                  }
                  , isActive: function (tab) {
                      return tab == $scope.Content.organize.tabs.current;
                  }
                  , select: function (tab) {
                      $scope.Content.organize.tabs.current = tab;

                      if (tab == $scope.Content.organize.tabs.types.edit) {
                          $scope.Content.organize.edit.fill();
                      }
                  }
               }
              , edit: {
                  form: {
                      name: ""
                     , groupId: 0
                     , isPrivate: false
                     , isActive: true // 1, 2, 3 -- Active, Inactive, Archived
                     , themeId: "1"
                     , handicapType: "Official"
                     , isUserHandicapUpdateAllowed: false
                     , isAdminRestricted : false
                  }
                 , fill: function () {
                     $scope.Content.organize.edit.form.groupId = $scope.Group.id;
                     $scope.Content.organize.edit.form.name = $scope.Group.name;
                     $scope.Content.organize.edit.form.isPrivate = $scope.Group.isPrivate;
                     $scope.Content.organize.edit.form.isActive = $scope.Group.isActive;
                     $scope.Content.organize.edit.form.themeId = $scope.Group.themeId.toString();
                     $scope.Content.organize.edit.form.createdBy = $scope.Group.createdBy;
                     $scope.Content.organize.edit.form.handicapType = $scope.Group.handicapType;
                     $scope.Content.organize.edit.form.isUserHandicapUpdateAllowed = $scope.Group.isUserHandicapUpdateAllowed;
                     $scope.Content.organize.edit.form.isAdminRestricted = $scope.Group.isAdminRestricted;
                 }
                 , save: function (isValid) {
                     if (isValid) {
                         ggFunctions.toggleProcessing(true);
                         ggGroupSvc.setup.updateGroup($scope.Content.organize.edit.form).then(function (data) {
                             if (data && data.status == "200") {


                                 // Group is setup, add default membership
                                 if ($scope.Content.organize.edit.form.isActive) {
                                     $scope.PopupAlert.success("Updated!", "The group has been updated");
                                 } else {
                                     var btn = new ggAlertSvc.button;
                                     btn.name = "Continue";
                                     btn.path = app.modules.view.routes.intro.path;

                                     $scope.PopupAlert.fail("Deleted!", "The group has been deleted and will no longer be available.", [btn]);
                                 }

                                 $scope.Group = data.data;
                                 $scope.Group.createdBy = $scope.Content.organize.edit.form.createdBy;

                             }
                         }, function (error) {
                             $scope.PopupAlert.fail("Error", error.statusText);
                         }).finally(function () {
                             ggFunctions.toggleProcessing(false);
                         });
                     }
                 }
              }

           }
           , reports: {
               tabs: {
                   current: 1
                   , types: {
                       scores: 1
                       , wagers: 2
                       , handicaps: 3
                       , stats : 4
                   }
                   , isActive: function (t) {
                       return t == $scope.Content.reports.tabs.current;
                   }
                   , select : function(t){
                       $scope.Content.reports.tabs.current = t;
                       if (t == 1) {
                           $scope.Content.reports.templateURL = "app/reports/scores-report.html";
                       }
                       if (t == 2) {
                           $scope.Content.reports.templateURL = "app/reports/wagers-report.html";
                       }
                       if (t == 3) {
                           $scope.Content.reports.templateURL = "app/reports/handicaps-report.html";
                       }
                       if (t == 4) {
                           $scope.Content.reports.templateURL = "app/reports/stats-report.html";
                       }
                    }
               }
               , templateURL: "app/reports/scores-report.html"
           }
        }

        $scope.f = {
            getTheme: function (themeId) {
                var rv = "";
                for (var x = 0; x < ggThemes.length; x++) {
                    if (ggThemes[x].themeId == themeId) {
                        rv = ggThemes[x].className;
                        break;
                    }
                }
                return rv;
            }
           , isSwiper: function () {
               $scope.Temp.isSwiper = true;
               $timeout(function () {
                   $scope.Temp.isSwiper = false
               }, 1000);
           }
           , toggleJumboContent: function () {
               $scope.Temp.isJumboExpanded = !$scope.Temp.isJumboExpanded;
           }
           , pickMembers: function (data) {

               // Should be a list of members
               

               var updateGroupMembership = function (data) {
                   return ggGroupSvc.membership.autoJoinGroup({ groupId: $scope.Group.id, memberId: data.id });
               }

               // Refresh Member List
               var fetchMembers = function () {
                   $scope.Content.invited.confirmed.isSearch = true;
                   return ggMemberSearchSvc.search.fetchMemberSearchByGroup({ groupId: $scope.Group.id }).then(function (data) {
                       if (data && data.status == "200") {
                           var lst = data.data.value;
                           $scope.Content.invited.confirmed.results = lst;
                       }
                       return;
                   });
               }

               var forms = data;
               ggFunctions.toggleProcessing(true);
               ggFunctions.qSequence(updateGroupMembership, data).then(function () {
                   return fetchMembers();
               }).finally(function () {
                   ggFunctions.toggleProcessing(false);
                   $scope.Content.invited.confirmed.isSearch = true;
               });


           }
           , isPrivate: function () {
               return $scope.Group ? $scope.Group.isPrivate : false;
           }
           , isPageMember: function () {
               return $scope.Temp.isPageMember || false;
           }
           , isPageAdmin: function () {
               return $scope.Temp.isPageAdmin || false;
           }
            , isRestricted: function () {
                return $scope.Group ? $scope.Group.isAdminRestricted : false;
            }
           , isInvited: function () {
               var rv = false;
               if (!$scope.f.isPageMember()) {
                   if ($scope.Temp.invitationId != '') {
                       rv = true;
                   }
               }
               return rv;
           }
           , formatDateString: function (d) {
               return ggFunctions.formatDateString(d, "m/d/yyyy", false);
           }
           , notFound: function () {
               console.log("Group not found.");
               $scope.Group = {
                   id: 0
                  , name: "404"

               }

               var btn = new ggAlertSvc.button;
               btn.name = "Continue";
               btn.path = app.modules.view.routes.intro.path;
               $scope.PopupAlert.fail("Fore!", "The group you requested was not found.", [btn])

           }
           , joinGroup: function () {

               var updateGroupMembership = function () {
                   return ggGroupSvc.membership.autoJoinGroup({ groupId: $scope.Group.id, memberId: app.Member.Detail.id }).then(function (data) {
                       if (data && (data.status == "200" || data.status == "201")) {
                           ggStorage.set(ggStorage.keys.groups.my.isCurrent, false); // Not current local groups
                           $scope.Temp.isPageMember = true;
                       }
                       return;
                   });
               }
               // Refresh Member Token
               var refreshMemberToken = function () {
                   return app.Member.Authenticate.RefreshToken();
               }
               // Refresh Member List
               var fetchMembers = function () {
                   return ggMemberSearchSvc.search.fetchMemberSearchByGroup({ groupId: $scope.Group.id }).then(function (data) {
                       if (data && data.status == "200") {
                           var lst = data.data.value;
                           $scope.Content.invited.confirmed.results = lst;
                       }
                       return;
                   });
               }


               // Process request
               if (!$scope.f.isPageMember()) {
                   ggFunctions.toggleProcessing(true);
                   updateGroupMembership().then(function () {
                       return refreshMemberToken();
                   }).then(function () {
                       return fetchMembers();
                   }).finally(function () {
                       ggFunctions.toggleProcessing(false);
                       if ($scope.f.isPageMember()) {
                           $scope.PopupAlert.success("Welcome", "Welcome to the group.  You can now play in group events!");
                       } else {
                           $scope.PopupAlert.fail("Error", "There was an error processing the invitation.");
                       }
                   });
               } else {
                   $scope.PopupAlert.warn("Hey There.", "You are already a member of the group.");
               }

           }
           , leaveGroup: function () {
               if ($scope.f.isPageAdmin()) {
                   $scope.PopupAlert.warn("Sorry", "As the group organizer, you cannot leave the group.");
               } else {

                   var updateGroupMembership = function () {
                       return ggGroupSvc.membership.autoLeaveGroup({ groupId: $scope.Group.id, memberId: app.Member.Detail.id }).then(function (data) {
                           if (data && (data.status == "200" || data.status == "201")) {
                               ggStorage.set(ggStorage.keys.groups.my.isCurrent, false); // Not current local groups
                               $scope.Temp.isPageMember = false;
                           }
                           return;
                       });
                   }
                   // Refresh Member Token
                   var refreshMemberToken = function () {
                       return app.Member.Authenticate.RefreshToken();
                   }
                   // Refresh Member List
                   var fetchMembers = function () {
                       return ggMemberSearchSvc.search.fetchMemberSearchByGroup({ groupId: $scope.Group.id }).then(function (data) {
                           if (data && data.status == "200") {
                               var lst = data.data.value;
                               $scope.Content.invited.confirmed.results = lst;
                           }
                           return;
                       });
                   }

                   // Process
                   ggFunctions.toggleProcessing(true);
                   updateGroupMembership().then(function () {
                       return refreshMemberToken();
                   }).then(function () {
                       return fetchMembers();
                   }).finally(function () {
                       ggFunctions.toggleProcessing(false);
                       if (!$scope.f.isPageMember()) {
                           $scope.PopupAlert.success("Goodbye", "We're sorry to see you go!");
                       } else {
                           $scope.PopupAlert.fail("Error", "There was an error processing the request.");
                       }
                   });

               }
           }
           , acceptInvitation: function () {

               var updateInvitation = function () {
                   var form = {
                       id: $scope.Temp.invitationId
                      , responseType: ggInvitationSvc.responseTypes.accept
                      , memberId: app.Member.Detail.id
                   };
                   return ggInvitationSvc.invite.updateInvitationResponse(form).then(function (data) {
                       app.Member.Network.Data.Invitations.unfollow($scope.Temp.invitationId);// remove invite from my object
                       ggStorage.set(ggStorage.keys.invitations.my.isCurrent, false); // Not current local invitations
                       $scope.Temp.invitationId = 0;
                       return;
                   });
               }
               var updateGroupMembership = function () {
                   return ggGroupSvc.membership.autoJoinGroup({ groupId: $scope.Group.id, memberId: app.Member.Detail.id }).then(function (data) {
                       if (data && (data.status == "200" || data.status == "201")) {
                           ggStorage.set(ggStorage.keys.groups.my.isCurrent, false); // Not current local groups
                           $scope.Temp.isPageMember = true;
                       }
                       return;
                   });
               }
               // Refresh Member Token
               var refreshMemberToken = function () {
                   return app.Member.Authenticate.RefreshToken();
               }
               // Refresh Member List
               var fetchMembers = function () {
                   return ggGroupSvc.membership.fetchGroupMembership({ groupId: $scope.Group.id }).then(function (data) {
                       if (data && data.status == "200") {
                           var lst = data.data.value;
                           $scope.Content.invited.confirmed.results = lst;
                       }
                       return;
                   });
               }

               // Process
               ggFunctions.toggleProcessing(true);
               updateInvitation().then(function () {
                   return updateGroupMembership()
               }).then(function () {
                   return refreshMemberToken();
               }).then(function () {
                   return fetchMembers()
               }).finally(function () {
                   ggFunctions.toggleProcessing(false);
                   if ($scope.f.isPageMember()) {
                       $scope.PopupAlert.success("Welcome", "Welcome to the group.  You can now play in group events!");
                   } else {
                       $scope.PopupAlert.fail("Error", "There was an error processing the invitation.");
                   }
               });

           }
        }

        // Check for Score Parameter
        if ($routeParams) {

            // is New Setup
            if ($routeParams.isNew) {
                $scope.View.tabs.current = $scope.View.tabs.types.invited;
                $scope.Content.invited.tabs.current = $scope.Content.invited.tabs.types.add;
            }

            if (!$routeParams.groupId) {
                // No Group Id.  Shame on you.
                $scope.Content.init();
            } else {
                ggFunctions.toggleProcessing(true);

                ggGroupSvc.search.fetchGroupDetail({ groupId: $routeParams.groupId }).then(function (data) {
                    if (data && data.status == "200") {
                        $scope.Group = data.data;
                    }
                }).finally(function () {
                    ggFunctions.toggleProcessing(false);
                    $scope.Content.init();
                });
            }
        }

        var userId = +ggStorage.get(ggStorage.keys.member.id);

        vm.memories = null;
        vm.groupId = +$routeParams.groupId;
        vm.addMemory = addMemory;
        vm.getMemoryList = getMemoryList;
        vm.canEditMemberProfile = canEditMemberProfile;

        function parseDate(dateString) {
            var match = rDateExtract.exec(dateString);
            return match ? new Date(match[1], match[2] - 1, match[3]) : null;
        }

        function addMemory() {
            $scope.memoryList.addMemory();
        }
        function getMemoryList() {
            vm.memories = GroupMemory.query({ groupId: vm.groupId })
            
        }
        function canEditMemberProfile(member) {
            return member.createdBy && member.createdBy.id === userId;
        }

        // Since you cannot have nested ngViews, we are going to simulate one.  If url contains "~" then 
        // prevent loading in ngView and load inside of my custom div (with the ng-include).
        // Do not use ggEvents.subscribe since it uses $rootScope.
        $scope.$on('$routeChangeStart', routeChangeStart);
        function routeChangeStart(event, next, current) {
            var url = $location.url();
            if (url.charAt(1) == '~') {
                event.preventDefault();
                $scope.reportTemplateUrl = url.slice(2);
            }
        }
    }
}(angular, app));

